import { omniaResolve } from "@omnia/shared/promises";
import { INgRegistrationContext, IOmniaSession } from "@omnia/types";


interface MigrationStatus {


    /** First year on which the new version should be active */
    firstYear: number

    /**
     * If set, indicates that a change of first year has been requested,
     * and that the request is pending or being processed
     */
    nextYear: number

}

export class NutritionVersionService {

    static $inject = [
        "OmniaSession"
    ]


    private initPromise: PromiseLike<any>
    private status: MigrationStatus

    constructor(
        private readonly session: IOmniaSession,
        private readonly http = session.http
    ) {
        this.initialize()
    }

    initialize() {

        const url = "/api/nutrition2/v1/migration/status"

        this.initPromise = this.http.get<MigrationStatus>(url, false).then(r => {

            this.status = r.data
            this.initPromise = undefined

        })

    }

    setFirstYear(year: number) {

        const url = `/api/nutrition2/v1/migration/status/${year}`

        return this.http.post<MigrationStatus>(url, undefined).then(r => {
            this.status = r.data
        })

    }

    get firstYear() {
        return this.status?.firstYear
    }

    get nextYear() {
        return this.status?.nextYear
    }

    ensureInit(): PromiseLike<any> {
        return this.initPromise ?? omniaResolve()
    }

    getCurrentVersion(): 1 | 2 | undefined {

        const { session, status } = this

        if (status?.firstYear === undefined) {
            return undefined
        }

        const year = status.nextYear || status.firstYear

        return (year <= session.yearId)
            ? 2
            : 1

    }
}